"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.NORWAY = void 0;

var _metadataMin = require("libphonenumber-js/metadata.min.json");

var _utils = require("@staccx/utils");

var NORWAY = {
  name: "NO",
  code: "47"
};
exports.NORWAY = NORWAY;

var _default = (0, _utils.distinct)(Object.keys(_metadataMin.countries).map(function (name) {
  return {
    code: _metadataMin.countries[name][0],
    name: name
  };
}).sort(function (a, b) {
  return parseInt(a.code, 10) < parseInt(b.code, 10);
}), "code");

exports["default"] = _default;